// src/context/CompanyInfoContext.js
import React, { createContext, useState, useEffect } from 'react';

const CompanyInfoContext = createContext();

export const CompanyInfoProvider = ({ children }) => {
  const [companyName, setCompanyName] = useState('Suruchi Blossoms');
  const [companyLogo, setCompanyLogo] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchCompanyInfo = async () => {
      try {
        // Check if already cached in sessionStorage
        const cachedName = sessionStorage.getItem('companyName');
        const cachedLogo = sessionStorage.getItem('companyLogo');

        if (cachedName && cachedLogo !== null) {
          setCompanyName(cachedName);
          setCompanyLogo(cachedLogo);
          setLoading(false);
          return;
        }

        // Fetch both settings in parallel instead of one after the other.
        const [nameRes, logoRes] = await Promise.all([
          fetch(`${process.env.REACT_APP_API_URL}/api/settings/companyName`),
          fetch(`${process.env.REACT_APP_API_URL}/api/settings/companyLogo`),
        ]);

        if (nameRes.ok && isMounted) {
          const name = await nameRes.json();
          setCompanyName(name);
          sessionStorage.setItem('companyName', name);
        }

        if (logoRes.ok && isMounted) {
          const logo = await logoRes.json();
          setCompanyLogo(logo);
          sessionStorage.setItem('companyLogo', logo);
        }

        if (isMounted) {
          setLoading(false);
        }
      } catch (err) {
        console.error('Error fetching company info:', err);
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchCompanyInfo();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <CompanyInfoContext.Provider value={{ companyName, companyLogo, loading }}>
      {children}
    </CompanyInfoContext.Provider>
  );
};

export default CompanyInfoContext;
